import { render, staticRenderFns } from "./SafetyObservationPriorityNewForm.vue?vue&type=template&id=82d9e8bc"
import script from "./SafetyObservationPriorityNewForm.vue?vue&type=script&lang=js"
export * from "./SafetyObservationPriorityNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports